import { useQuery } from '@apollo/client';
import type { DealFetchRes } from '@openx/components-deal/lib/utils/context/DealHookTypes';
import type { DealApi, DealOaApi } from '@openx/types/deal';
import { GetDealDocument } from '../../../graphql/query/deals/GetDeal.generated';
import { formatDeal } from '../../../modules/deals/utils/formatDeal';

export const useDealFetch = <T extends DealApi = DealOaApi>(dealUid: string): DealFetchRes<T> => {
  const {
    data: { dealById: dealRaw } = {},
    loading,
    refetch,
  } = useQuery(GetDealDocument, { skip: !dealUid, variables: { id: dealUid } });

  return {
    deal: formatDeal(dealRaw),
    loading,
    refetch,
  };
};
